import { Enum, EnumType } from 'ts-jenum';

@Enum<AppointmentsViewEnum>('value')
export class AppointmentsViewEnum extends EnumType<AppointmentsViewEnum>() {
   static readonly DAY = new AppointmentsViewEnum(0, 'brick.brick_definitions.directory_browser.settings.appointments.views.day');
   static readonly WEEK = new AppointmentsViewEnum(1, 'brick.brick_definitions.directory_browser.settings.appointments.views.week');
   static readonly MONTH = new AppointmentsViewEnum(2, 'brick.brick_definitions.directory_browser.settings.appointments.views.month');
   static readonly AGENDA = new AppointmentsViewEnum(3, 'brick.brick_definitions.directory_browser.settings.appointments.views.agenda');

   private constructor(public value: number, public translationKey: string) {
      super();
   }
}
